import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import NavBar from '../../shared/NavBar';
import ViewArticle from '../Blog/ViewArticle';
import PulseMetadata from '../Blog/PulseMetadata';
import { guideContent } from './guideContent.js';
import { guidePaths } from './guidePaths.js';
import { guideSnapshots } from './guideSnapshots.js';
import '../Blog/Blog.css';

export default function GhostGuidePage() {
  const { pathname } = useLocation();
  const slug = guidePaths[pathname.replace(/\/+$/, '')];
  const [loaded, setLoaded] = useState(null);
  const article = loaded?.slug === slug ? loaded : guideSnapshots[slug];
  useEffect(() => {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 8000);
    const url = new URL(`https://blogadmin.shuttleops.com/ghost/api/content/posts/slug/${slug}/`);
    url.search = new URLSearchParams({ key: '4cfffa548d3e48f0a47d440703', include: 'tags,authors' });
    fetch(url, { signal: controller.signal }).then(response => {
      if (!response.ok) throw new Error('Guide unavailable');
      return response.json();
    }).then(({ posts }) => {
      if (!controller.signal.aborted && posts?.[0]?.html && posts[0].slug === slug) setLoaded(guideContent(posts[0]));
    }).catch(() => { /* The bundled article stays readable during a Ghost outage. */ })
      .finally(() => clearTimeout(timer));
    document.getElementById('root')?.scrollTo(0, 0);
    return () => { controller.abort(); clearTimeout(timer); };
  }, [slug]);
  return <><header className="guide-navigation"><NavBar /></header>
    <PulseMetadata article={article} />
    <script type="application/ld+json">{JSON.stringify(guideSnapshots[slug].structuredData)}</script>
    <ViewArticle article={article} guide />
  </>;
}
